import { Component, OnInit, HostListener, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-whyus-footer',
  templateUrl: './whyus-footer.component.html',
  styleUrls: ['./whyus-footer.component.less']
})
export class WhyusFooterComponent implements OnInit {

  @Output() removeActiveInHeader = new EventEmitter();
  selectedMenu = false;
  year: string;
  constructor(private router: Router) {

  }

  ngOnInit() {
    this.year = (new Date()).getFullYear().toString();
  }

  canceltoggleEmp() {
    localStorage.setItem("tab_value", "0");
    this.router.navigate(['/service']);
  }
  canceltoggleEmp1() {
    localStorage.setItem("tab_value", "4");
    this.router.navigate(['/service']);
  }
}
